'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _themeCart = require('@shopify/theme-cart');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  update();
  bindUIActions();
};

//Get Line Item Key
// es6-promise breaks things in ie11. commenting out these and using
// polyfill.io instead until there's a better solution
// import 'unfetch/polyfill';
// import 'es6-promise/auto'
var getLineItemKey = function getLineItemKey(current, key) {
  var lineitem = (0, _jquery2.default)(current).closest(_dom2.default.lineItem);
  if (!key) {
    key = lineitem.data('key');
  }
  return key;
};

var toggleCart = function toggleCart(state) {
  if (state === 'show') {
    (0, _jquery2.default)(_dom2.default.inlineCart).addClass('is-active');
    (0, _jquery2.default)(_dom2.default.overlay).addClass('cart-is-active');
    (0, _jquery2.default)('body').addClass('cart-is-active');
    (0, _jquery2.default)(_dom2.default.siteContainer).addClass('cart-is-active');
  } else if (state === 'hide') {
    (0, _jquery2.default)(_dom2.default.inlineCart).removeClass('is-active');
    (0, _jquery2.default)(_dom2.default.overlay).removeClass('cart-is-active');
    (0, _jquery2.default)('body').removeClass('cart-is-active');
    (0, _jquery2.default)(_dom2.default.siteContainer).removeClass('cart-is-active');
  }
};

var update = function update() {
  (0, _themeCart.getState)().then(function (cart) {
    var itemCount = cart.item_count;

    if (itemCount == 0) {
      itemCount = 'Ø';
    }

    (0, _jquery2.default)(_dom2.default.cartItemCount).text(itemCount);
  });

  _jquery2.default.get('/cart?view=inline-cart-contents').then(function (response) {
    (0, _jquery2.default)(_dom2.default.inlineCart).find(_dom2.default.inlineCartContent).html(response);
  }).done(function () {
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  });

  if ((0, _jquery2.default)(_dom2.default.cartPage).length > 0) {
    _jquery2.default.get('/cart?view=contents').then(function (response) {
      (0, _jquery2.default)(_dom2.default.cartPage).find(_dom2.default.cartPageContent).html(response);
    }).done(function () {
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });
  }
};

var addLineItem = function addLineItem(id, qty, properties) {
  (0, _themeCart.addItem)(id, { qty: qty, properties: properties }).then(function (item) {
    update();
    setTimeout(function () {
      toggleCart('show');
    }, 200);
  });
};

var quantityAdjust = function quantityAdjust(current) {
  var qtyInput = (0, _jquery2.default)(current).closest(_dom2.default.qty).find(_dom2.default.qtyInput);
  var qty = parseInt(qtyInput.val());

  if ((0, _jquery2.default)(current).attr('data-quantity-minus') != undefined) {
    qty = qty - 1;
    if (qty <= 0) {
      qty = 0;
    }
  } else {
    qty = qty + 1;
  }

  qtyInput.val(qty).trigger('change');
};

var quantityUpdate = function quantityUpdate(current) {
  var qty = parseInt((0, _jquery2.default)(current).val());

  if (qty > 0) {
    updateLineItem(current, qty);
  } else {
    removeLineItem(current);
  }
};

//Update Line Item
var updateLineItem = function updateLineItem(current, quantity, properties) {
  var key = getLineItemKey(current);

  (0, _themeCart.updateItem)(key, { quantity: quantity, properties: properties }).then(function (cart) {
    update();
  });
};

//Remove Line Item
var removeLineItem = function removeLineItem(current) {
  var key = getLineItemKey(current);

  (0, _themeCart.removeItem)(key).then(function (cart) {
    update();
  });
};

var bindUIActions = function bindUIActions() {

  //Display Cart
  (0, _jquery2.default)(document).on('click', _dom2.default.inlineCartTrigger, function (e) {
    e.preventDefault();
    toggleCart('show');

    var headerOffset = (0, _jquery2.default)(_dom2.default.headerMarker).offset().top;

    if (headerOffset > (0, _jquery2.default)(window).scrollTop()) {
      (0, _jquery2.default)('html, body').animate({
        scrollTop: headerOffset
      }, 500);
    }
  });

  (0, _jquery2.default)(document).on('click', _dom2.default.inlineCartCloseTrigger, function () {
    toggleCart('hide');
  });

  (0, _jquery2.default)(_dom2.default.overlay).on('click', function () {
    toggleCart('hide');
  });

  //Add Line Item
  (0, _jquery2.default)(document).on('click', _dom2.default.addItem, function (e) {
    e.preventDefault();

    var id = parseInt((0, _jquery2.default)(this).closest('form').find(_dom2.default.addVariant).val());

    //Bold RO
    var frequencyNum = (0, _jquery2.default)('.bold-ro__frequency-num').val();
    var frequencyType = (0, _jquery2.default)('.bold-ro__frequency-type').val();
    var frequencyTypeText = (0, _jquery2.default)('.bold-ro__frequency-type option[value="' + frequencyType + '"]').text();
    var groupId = (0, _jquery2.default)('.bold-ro__group-id').val();
    var discountedPrice = (0, _jquery2.default)('bold-ro__discounted-price').val();
    var discountPercentage = (0, _jquery2.default)('.bold-ro__discount-percentage').val();
    var unformattedPrice = (0, _jquery2.default)('.bold-ro__unformatted-price').val();

    var properties = void 0;

    if ((0, _jquery2.default)(_dom2.default.subscriptionOptions).hasClass('is-active')) {
      properties = {
        "frequency_num": frequencyNum,
        "frequency_type": frequencyType,
        "frequency_type_text": frequencyTypeText,
        "group_id": groupId,
        "discounted_price": discountedPrice,
        "_ro_discount_percentage": discountPercentage,
        "_ro_unformatted_price": unformattedPrice
      };
    }

    addLineItem(id, 1, properties);
  });

  //Update QTY
  (0, _jquery2.default)(document).on('click', _dom2.default.qtyAdjust, function () {
    quantityAdjust(this);
  });

  (0, _jquery2.default)(document).on('blur, change', _dom2.default.qtyInput, function () {
    quantityUpdate(this);
  });

  //Remove Line Item
  (0, _jquery2.default)(document).on('click', _dom2.default.lineItemRemoveTrigger, function () {
    removeLineItem(this);
  });
};